export const isEmpty = (obj: object) => Object.keys(obj).length === 0;

export default isEmpty;
